const styleSheet = () => ({
  textContainer: {
    marginTop: '15px',
    color: 'rgba(99, 115, 164, 1)',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '21px',
    textAlign: 'left',
  },
  linkText: {
    marginLeft: '5px',
    color: 'rgba(8, 95, 229, 1)',
  },
});

export default styleSheet;
